/*
 * Copyright (C) 2019-2021 HERE Europe B.V.
 * Licensed under Apache 2.0, see full license in LICENSE
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Provides a manager that orchestrates downloading URLs, particularly static map resources.
 *
 * @remarks
 *
 * @packageDocumentation
 */

export * from "./src/TransferManager";
